import { composeLabelsWithEditConfig } from "src/common/attributes/makeAttrLabel/utils/composeLabelWithConf";
import { walk } from "src/components/TreeStd";
import { ZAttribute } from "src/types/ZAttribute";
import { ZAttrLabelTreeData } from "../types/ZAttrLabelTreeData";

export const formatAllLabels = (
  labelTreeData: ZAttrLabelTreeData[],
  allAttributes: ZAttribute[],
  typesMap: Record<number, string>,
) => {
  const copy = JSON.parse(
    JSON.stringify(labelTreeData),
  ) as ZAttrLabelTreeData[];
  const attrMap = new Map(allAttributes.map((e) => [e.id, e]));
  walk((node) => {
    const attr = attrMap.get(node.attrId);
    if (!attr) return;
    const newLabels = node.labels?.filter((label) => !!label);
    // eslint-disable-next-line no-param-reassign
    node.labels = composeLabelsWithEditConfig(attr, newLabels || [], typesMap);
  }, copy);
  return copy;
};
